import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './link-button.scss';

const LinkButton = ({ children, ...props }) => {
  const buttonProps = omit(
    props,
    'currentUser',
    'isBlocked',
    'isOwner',
    'dispatch',
    'viewMode',
    'isDemoMode',
    'openModal',
    'isAuthenticated',
    'titleFontClassName',
  );

  return (
    <button className={classNames(styles.button, 'page-link-color', 'page-link-font')} {...buttonProps}>
      {children}
    </button>
  );
};

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LinkButton;
